<template>
	<div class="tasks">
		<p> {{ completedTasks?.value?.length }}/{{ tasks?.value?.length }} tasks completed </p>
		<slot />
		<div v-if="isClient" class="timeContainer">
			<span class="icon" />
			<time-counter />
		</div>
	</div>
</template>

<script>
import TimeCounter from "../TimeCounter.vue";

export default {
	components: { TimeCounter },
	inject: {
		tasks: { type: Array },
		completedTasks: { type: Array },
	},
	props: {
		isClient: { type: Boolean, default: true }
	},
};
</script>